import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-pie-chart',
  templateUrl: './pie-chart.component.html',
  styleUrls: ['./pie-chart.component.css']
})
export class PieChartComponent {

    // Pie
    @Input() public pieChartLabels: string[] = ['Download Sales', 'In-Store Sales', 'Mail Sales'];
    @Input() public pieChartData: number[] = [300, 500, 100];
    public pieChartType = 'pie';

    // events
    public chartClicked(e: any): void {
      console.log(e);
    }

    public chartHovered(e: any): void {
      console.log(e);
    }

  constructor() { }

}



// WEBPACK FOOTER //
// ./src/app/report/charts/pie-chart/pie-chart.component.ts